import apiService from "./apiService";

const transactionService = {
    async search(page, searchModel) {
        try {
            return (await apiService.post(`t/search/${page}`, searchModel, true)).data;
        }
        catch {
            return { currentPage: 1, totalItems: 0, totalPages: 1, logs: [] };
        }
    },
    async getInfo(id) {
        try {
            return (await apiService.get(`t/getinfo/${id}`, {}, true)).data;
        }
        catch {
            return { currentPage: 1, totalItems: 0, totalPages: 1, logs: [] };
        }
    },
    async getCtcInfo(id) {
        try {
            return (await apiService.get(`t/get-ctc-info/${id}`, {}, true)).data;
        }
        catch {
            return { currentPage: 1, totalItems: 0, totalPages: 1, logs: [] };
        }
    },
    async saveForm51(request) {
        try {
            return (await apiService.post(`t/save`, request, true)).data;
        }
        catch {
            return { success: false, message: "An error occured while processing the request." };
        }
    },
    async delete(id) {
        try {
            return (await apiService.delete(`t/delete/${id}`, true)).data;
        }
        catch {
            return { success: false, message: "An error occured while processing the request." };
        }
    },
    async exclude(id) {
        try {
            return (await apiService.put(`t/excludefromrdcd/${id}`, {}, true)).data;
        }
        catch {
            return { success: false, message: "An error occured while processing the request." };
        }
    },
};

export default transactionService;